import ajax from '../../lib/ajaxAuth';
import Util from '@/lib/util';
import { Module, ActionContext } from 'vuex'
import UserProfile from '../entities/auth/UserProfile';
import Vendor from '../entities/auth/Vendor';
import Membership from '../entities/auth/Membership';
import AppConsts from '@/lib/appConst';
import User from '../entities/user'

interface SessionState {
    application: any,
    user: User,
    tenant: any,
    userProfile: UserProfile,
    vendor: Vendor,
    membership: Membership,
}
class SessionStore implements Module<SessionState, any>{
    namespaced = true;
    state: SessionState = {
        application: null,
        user: null,
        tenant: null,
        userProfile: null,
        vendor: null,
        membership: null
    };
    actions = {
        async init(context: ActionContext<SessionState, any>) {
            let resp = await ajax.get('/Session/GetCurrentLoginInformations', {
                headers: {
                    'TenantId': Util.abp.multiTenancy.getTenantIdCookie()
                }
            });

            let application = resp.data.result.application;
            let tenant = resp.data.result.tenant;
            let user = resp.data.result.user;
            let userProfile = resp.data.result.userProfile;
            let vendor = resp.data.result.vendor;
            let membership = resp.data.result.membership;

            if (vendor) {
                vendor.leafletExpiredTime = Util.formatDate(new Date(vendor.leafletExpiredTime), "yyyy.MM.dd HH:mm:ss");
            }

            if (membership) {
                membership.expiredTime = Util.formatDate(new Date(membership.expiredTime), "yyyy.MM.dd HH:mm:ss");
            }

            context.state.application = application;
            context.state.user = user;
            context.state.tenant = tenant;
            context.state.userProfile = userProfile;
            context.state.vendor = vendor;
            context.state.membership = membership;

            if (user) {
                Util.abp.session.setUserNoCookie(user.userNo)
                Util.abp.session.setPhoneNumberCookie(user.userName)
            }

            if (userProfile) {
                Util.abp.session.setUserAvatarCookie(userProfile.avatarImageUrl || AppConsts.user.avatar);
                Util.abp.session.setUserFullnameCookie(userProfile.fullName || '匿名*');
            }

            if (vendor) {
                Util.abp.session.setVendorNoCookie(vendor.vendorNo);
            }
        }
    }
}
const session = new SessionStore();
export default session;